import { App } from '../../App.js'

// eslint-disable-next-line
export default async (component, event, ui) => {
  App.editor.view.area.pointermove(event)
  const { x, y } = App.editor.view.area.mouse
  const newSequenceSingleNode = await component.createNode()
  newSequenceSingleNode.position = [x, y]

  App.editor.addNode(newSequenceSingleNode)

}